import Heading from '../../sharedComponents/Heading/Heading';
import './AboutUs.scss';
import AIAgent from '../../../assets/ai-agent.svg';
import Bolt from '../../../assets/icons/bolt.svg';
import SubBolt from '../../../assets/icons/sub-bolt.svg';
import Button from '../../sharedComponents/Button/Button';
function AboutUs() {
    return (
        <div id='alpha-perceptron-about-us' className='alpha-perceptron-aboutus'>
            <div className='alpha-perceptron-aboutus__section-one'>
                <div className='alpha-perceptron-aboutus__section-one__content'>
                    <Heading size='h2' type='primary' theme='dark' secondaryText='AlphaPerceptron' secondaryTextColor='#5D3587'>
                        The story of
                    </Heading>
                    <Heading size='h6' type='secondary' theme='dark'>
                        AlphaPerceptron began with a vision to pioneer groundbreaking AI research that pushes the boundaries of what's possible. We set out to tackle long-standing, ambitious problems that have challenged humanity for decades.
                    </Heading>
                    <Heading size='h6' type='secondary' theme='dark'>
                        While our initial focus was on revolutionary research in self-driving vehicles, drug discovery, and humanoid robots, we recognized the need for a sustainable approach to fund these ambitious goals. This led to our strategic pivot of developing commercial AI products that showcase our capabilities while generating the resources needed for our long-term vision.
                    </Heading>
                    <img className='alpha-perceptron-aboutus__section-one__content__image' src={AIAgent} alt='AI Agent' />
                </div>
            </div>
            <div className='alpha-perceptron-aboutus__section-two'>
                <div className='alpha-perceptron-aboutus__section-two__content'>
                    <div className='alpha-perceptron-aboutus__section-two__content__tag'>
                        <Heading size='h5' type='primary' theme='dark'>Mission</Heading>
                    </div>
                    <Heading
                        size='h5'
                        type='primary'
                        theme='dark'>
                        At AlphaPerceptron, our mission is to develop innovative AI solutions for complex global challenges. Through our relentless pursuit of excellence and cutting-edge technology, we aim to create AI-driven breakthroughs that significantly enhance human life.
                    </Heading>
                </div>
                <div className='alpha-perceptron-aboutus__section-two__content'>
                    <div className='alpha-perceptron-aboutus__section-two__content__tag'>
                        <Heading size='h5' type='primary' theme='dark'>Vision</Heading>
                    </div>
                    <Heading
                        size='h5'
                        type='primary'
                        theme='dark'>
                        Our roadmap reflects our determination to make a meaningful impact through AI:
                    </Heading>
                    <div className='alpha-perceptron-aboutus__section-two__content__points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__icon' src={Bolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h6'>
                            Near-term (1-2 years): Establishing our foundation through commercial products, strategic partnerships, and team building.
                        </Heading>
                    </div>
                    <div className='alpha-perceptron-aboutus__section-two__content__points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__icon' src={Bolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h6'>
                            Mid-term (3-4 years): Scaling our operations while investing significantly in our research initiatives.
                        </Heading>
                    </div>
                    <div className='alpha-perceptron-aboutus__section-two__content__points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__icon' src={Bolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h6'>
                            Long-term (5+ years): Delivering breakthrough innovations that transform transportation, healthcare, and robotics, ultimately enhancing human happiness and reducing pain worldwide.
                        </Heading>
                    </div>
                </div>
                <div className='alpha-perceptron-aboutus__section-two__content'>
                    <div className='alpha-perceptron-aboutus__section-two__content__tag'>
                        <Heading size='h5' type='primary' theme='dark'>Approach</Heading>
                    </div>
                    <Heading
                        size='h5'
                        type='primary'
                        theme='dark'>
                        We operate with a dual strategy that balances commercial viability with ambitious research:
                    </Heading>
                    <div className='alpha-perceptron-aboutus__section-two__content__points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__icon' src={Bolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h6'>
                            Commercial AI Products: We develop cutting-edge AI solutions like Atom and Atom Agents that generate revenue and establish our reputation in the industry.
                        </Heading>
                    </div>
                    <div className='alpha-perceptron-aboutus__section-two__content__points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__icon' src={Bolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h6'>
                            Long-term Research Initiatives: Profits from our commercial endeavors fuel our research in:
                        </Heading>
                    </div>
                    {/* Sub Points */}
                    <div className='alpha-perceptron-aboutus__section-two__content__points__sub-points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__sub-points__icon' src={SubBolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h7'>
                            Self-driving vehicles: Creating autonomous transportation technology that dramatically improves road safety while providing universal mobility access.
                        </Heading>
                    </div>
                    <div className='alpha-perceptron-aboutus__section-two__content__points__sub-points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__sub-points__icon' src={SubBolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h7'>
                            Drug discovery: Accelerating the identification and development of life-saving medications through AI-powered molecular modeling and predictive analytics.
                        </Heading>
                    </div>
                    <div className='alpha-perceptron-aboutus__section-two__content__points__sub-points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__sub-points__icon' src={SubBolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h7'>
                            Humanoid robots: Creating versatile robotic assistants that seamlessly integrate into households, providing care for the elderly and handling everyday chores with human-like dexterity.
                        </Heading>
                    </div>
                    <div className='alpha-perceptron-aboutus__section-two__content__points__sub-points'>
                        <img className='alpha-perceptron-aboutus__section-two__content__points__sub-points__icon' src={SubBolt} alt='vision' />
                        <Heading type='primary' theme='dark' size='h7'>
                            Movie generation: Pioneering AI systems that transform simple concepts into immersive cinematic experiences, democratizing creative storytelling and revolutionizing entertainment production.
                        </Heading>
                    </div>
                </div>
                <div className='alpha-perceptron-aboutus__section-two__content'>
                    <div className='alpha-perceptron-aboutus__section-two__content__tag'>
                        <Heading size='h5' type='primary' theme='dark'>Core Values</Heading>
                    </div>
                    <div className='alpha-perceptron-aboutus__section-two__content__box-container'>
                        <div className='alpha-perceptron-aboutus__section-two__content__box'>
                            <Heading type='primary' theme='dark' size='h5'>
                                Innovation
                            </Heading>
                            <Heading type='secondary' theme='dark' size='h7'>
                                Pushing the boundaries of what AI can accomplish
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-aboutus__section-two__content__box'>
                            <Heading type='primary' theme='dark' size='h5'>
                                Integrity
                            </Heading>
                            <Heading type='secondary' theme='dark' size='h7'>
                                Upholding the highest ethical standards in AI development
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-aboutus__section-two__content__box'>
                            <Heading type='primary' theme='dark' size='h5'>
                                Collaboration
                            </Heading>
                            <Heading type='secondary' theme='dark' size='h7'>
                                Fostering partnerships that accelerate progress
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-aboutus__section-two__content__box'>
                            <Heading type='primary' theme='dark' size='h5'>
                                Excellence
                            </Heading>
                            <Heading type='secondary' theme='dark' size='h7'>
                                Delivering exceptional quality in everything we do
                            </Heading>
                        </div>
                    </div>
                </div>
                <div className='alpha-perceptron-aboutus__section-two__content'>
                    <div className='alpha-perceptron-aboutus__section-two__content__tag'>
                        <Heading size='h5' type='primary' theme='dark'>Our Team</Heading>
                    </div>
                    <div className='alpha-perceptron-aboutus__section-two__content__points'>
                        <Heading type='primary' theme='dark' size='h6'>
                            AlphaPerceptron is powered by a collective of exceptional minds - brilliant AI engineers, researchers, and innovators at the forefront of artificial intelligence. Our team combines advanced degrees from prestigious institutions with practical expertise in machine learning, neural networks, and computational modeling. Our researchers have backgrounds spanning computer science, mathematics, robotics, and cognitive science, bringing multidisciplinary perspectives to complex AI challenges. This diversity of thought enables us to approach problems with unique insights and creative solutions. United by a shared passion for pushing technological boundaries, our team members have contributed to significant advancements in natural language processing, computer vision, and reinforcement learning before joining our mission to create transformative AI technologies. While small and agile today, our team's technical prowess and innovative thinking rival those of much larger organizations, allowing us to move quickly and decisively toward our ambitious goals.                        </Heading>
                    </div>
                </div>

            </div>
            <div className='alpha-perceptron-aboutus__section-three'>
                <div className='alpha-perceptron-aboutus__section-three__content'>
                    <Heading size='h3' type='primary' theme='dark'>
                        Interested in Collaborating?
                    </Heading>
                    <Heading theme='dark' size='h7' type='secondary'>
                        We welcome partnerships with researchers, institutions, and industry leaders. If you’re interested in working with us, get in touch.
                    </Heading>
                    <Button size='medium' theme='dark' type='secondary'>
                        Contact Us
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;

